var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-tiktok 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 4H6C4.895 4 4 4.895 4 6V24C4 25.105 4.895 26 6 26H24C25.105 26 26 25.105 26 24V6C26 4.895 25.104 4 24 4ZM22.689 13.474C22.559 13.486 22.428 13.494 22.296 13.494C20.801 13.494 19.487 12.726 18.722 11.563C18.722 14.612 18.722 18.082 18.722 18.14C18.722 20.825 16.545 23.001 13.861 23.001C11.177 23 9 20.823 9 18.139C9 15.454 11.177 13.278 13.861 13.278C13.963 13.278 14.062 13.287 14.161 13.293V15.689C14.061 15.677 13.964 15.659 13.861 15.659C12.491 15.659 11.38 16.77 11.38 18.14C11.38 19.51 12.49 20.621 13.861 20.621C15.232 20.621 16.442 19.541 16.442 18.171C16.442 18.116 16.466 7.001 16.466 7.001H18.755C18.97 9.048 20.623 10.664 22.689 10.812V13.474Z",
    fill: "#182617"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokGreen);
export default __webpack_public_path__ + "static/media/tiktok-green.4fced06b4c55f2f053a49f6194fef42e.svg";
export { ForwardRef as ReactComponent };